export default __webpack_public_path__ + "static/media/circle-desktop.d8643c9a.svg";